// @ts-nocheck
import React, { useEffect, useState } from "react";
import Box from '@mui/material/Box';
import Typography from "@mui/material/Typography";
import SinapTheme from "../../styles/SinapTheme"
import makeStyles from '@mui/styles/makeStyles';
import Grid from '@mui/material/Grid';
import CircularProgress from "@mui/material/CircularProgress";
import { DialogContent as ModalContent } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useAreas } from "../../Areas/State/AreasContext";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

const useStyles = makeStyles(theme => ({
    iconos: {
        display: 'flex',
        justifyContent: 'flex-end',
        position: 'fixed',
        right: "32px",
    },
    typography: {
        width: "80%",
        padding: "3%",
        color: SinapTheme.palette.primary.main,
    },
    text: {
        fontsize: '20%'
    },
    subtitle: {
        color: SinapTheme.palette.primary.main,
    }
}))

export const VerInterno = ({ area }) => {
    const { fetchArea, areaData, areaSub, fetchSubgrupos } = useAreas()
    const classes = useStyles();
    const matches = useMediaQuery('(max-width:600px)');
    const [loading, setLoading] = useState(false);

    async function fetchSubgrups() {
        setLoading(true)
        await fetchSubgrupos(area) // Obtengo los subgrupos de area -> Se guarda en "areaSub"
        await fetchArea(area) // Obtengo la data que necesita el modal del area -> Se guarda en "areaData"
        setLoading(false)
    }

    useEffect(() => {
        fetchSubgrups();
    }, [])

    return <>
        <Box>
            {loading ?
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <CircularProgress color="secondary" />
                </div>
                :
                <>
                    <Grid container>
                        <ModalContent>
                            <Grid item xs={12}>
                                <>
                                    {matches ? (
                                        <div>
                                            <b>Subareas:</b>
                                            {Array.isArray(areaSub) && areaSub.length > 0 ? (
                                                <List style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                                                    {areaSub.map((subarea, index) => (
                                                        <ListItem key={index} style={{ width: 'auto' }}>
                                                            <ListItemText primary={subarea.name} />
                                                        </ListItem>
                                                    ))}
                                                </List>
                                            ) : (
                                                <Typography>Este área no posee subareas</Typography>
                                            )}
                                        </div>
                                    ) : (
                                        <Grid container spacing={2}>
                                            <Grid item xs={2}>
                                                <b>Subareas:</b>
                                            </Grid>
                                            <Grid item xs={10}>
                                                {Array.isArray(areaSub) && areaSub.length > 0 ? (
                                                    <List style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                                                        {areaSub.map((subarea, index) => (
                                                            <ListItem key={index} style={{ width: 'auto' }}>
                                                                <ListItemText primary={subarea.name} />
                                                            </ListItem>
                                                        ))}
                                                    </List>
                                                ) : (
                                                    <Typography>Este área no posee subareas</Typography>
                                                )}
                                            </Grid>
                                        </Grid>
                                    )}
                                </>
                            </Grid>
                            <br />
                            <Grid item xs={12}>
                                <p className={classes.text}>
                                    <b>
                                        Pertenece a:
                                    </b> {areaData.path}
                                </p>
                                {//integrantes

                                    areaData.integrantes.length === 0 ?
                                        <p >
                                            <b>Integrantes:</b> No exiten integrantes asociados al area
                                        </p> :
                                        matches ?
                                            <div>
                                                <b> Integrantes: </b>
                                                <List>
                                                    {
                                                        areaData.integrantes.map(user =>
                                                            <ListItem>
                                                                <ListItemText
                                                                    primary={user['nombre_completo']}
                                                                />
                                                            </ListItem>,
                                                        )
                                                    }
                                                </List>
                                            </div>
                                            :
                                            <Grid container spacing={2}>
                                                <Grid item xs={2}>
                                                    <b>
                                                        Integrantes:
                                                    </b>
                                                </Grid>
                                                <Grid item xs={10}>
                                                    {
                                                        areaData.integrantes.map(user =>
                                                            <ListItem>
                                                                <ListItemText
                                                                    primary={user['nombre_completo']}
                                                                    secondary={user['mail']}
                                                                />
                                                            </ListItem>,
                                                        )
                                                    }
                                                </Grid>
                                            </Grid>}
                                {//alias
                                    areaData.alias.length === 0 ?
                                        <p >
                                            <b>Alias:</b> No exiten alias asociados al area
                                        </p> :
                                        matches ?
                                            <div>
                                                <b >
                                                    Alias:
                                                </b>
                                                {
                                                    areaData.alias.map(alia =>
                                                        <ListItem>
                                                            <ListItemText
                                                                primary={alia}
                                                            />
                                                        </ListItem>,
                                                    )
                                                }
                                            </div>
                                            :
                                            <Grid container spacing={2}>
                                                <Grid item xs={2}>
                                                    <b>
                                                        Alias:
                                                    </b>
                                                </Grid>
                                                <Grid item xs={10}>
                                                    {areaData.alias.map(alia =>
                                                        <ListItem>
                                                            <ListItemText
                                                                primary={alia}
                                                            />
                                                        </ListItem>,
                                                    )
                                                    }
                                                </Grid>
                                            </Grid>
                                }
                                {//oficinas
                                    areaData.oficinas.length === 0 ?
                                        <p >
                                            <b>Oficinas:</b> No exiten oficinas asociados al area
                                        </p> :
                                        matches ?
                                            <div>
                                                <b> Oficinas: </b>
                                                <List>
                                                    {
                                                        areaData.oficinas.map(o =>
                                                            <ListItem>
                                                                <ListItemText
                                                                    primary={o}
                                                                />
                                                            </ListItem>,
                                                        )
                                                    }
                                                </List>
                                            </div>
                                            :
                                            <Grid container spacing={2}>
                                                <Grid item xs={2}>
                                                    <b>
                                                        Oficinas:
                                                    </b>
                                                </Grid>
                                                <Grid item xs={10}>
                                                    {areaData.oficinas.map(o =>
                                                        <ListItem>
                                                            <ListItemText
                                                                primary={o}
                                                            />
                                                        </ListItem>,
                                                    )
                                                    }
                                                </Grid>
                                            </Grid>}
                                {//internos
                                    areaData.internos.length === 0 ?
                                        <p >
                                            <b>Internos:</b> No exiten internos asociados al area
                                        </p> :
                                        matches ?
                                            <div>
                                                <b> Internos: </b>
                                                <List>
                                                    {
                                                        areaData.internos.map(interno =>
                                                            <ListItem>
                                                                <ListItemText
                                                                    primary={interno['especificacion'] === '' ? interno['numero'] :
                                                                        interno['numero'] + ' - ' + interno['especificacion']}
                                                                />
                                                            </ListItem>,
                                                        )
                                                    }
                                                </List>
                                            </div>
                                            :
                                            <Grid container spacing={2}>
                                                <Grid item xs={2}>
                                                    <b>
                                                        Internos:
                                                    </b>
                                                </Grid>
                                                <Grid item xs={10}>
                                                    {
                                                        areaData.internos.map(interno =>
                                                            <ListItem>
                                                                <ListItemText
                                                                    primary={interno['especificacion'] === '' ? interno['numero'] :
                                                                        interno['numero'] + ' - ' + interno['especificacion']}
                                                                />
                                                            </ListItem>,
                                                        )
                                                    }
                                                </Grid>
                                            </Grid>}

                                <p className={classes.text}>
                                    <b>
                                        Observaciones:
                                    </b>  {areaData.observaciones === '' ? "No hay observaciones" : areaData.observaciones}
                                </p>
                            </Grid>
                        </ModalContent>
                    </Grid>
                </>}
        </Box >
    </>
}